var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.items),function(item){return _c('breadcrumb',{key:item.id,attrs:{"active":item.id === _vm.currentItem,"href":item.link ? item.link : '#',"title":item.name},on:{"click":function($event){return _vm.$emit('item-click', item.id)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }